/** SKU / variant expand — ใช้กับหน้า product2 ทุก marketplace */
import PdMobileSticky from '@/views/customer/product2/PdMobileSticky.vue'

const SKU_COLLAPSE_AT = 999
const COLOR_COLLAPSE_AT = 10

export default {
  components: {
    PdMobileSticky,
  },
  data() {
    return {
      skuExpanded: false,
      colorExpanded: false,
      previewSkuId: '',
      thumbCanScrollUp: false,
      thumbCanScrollDown: false,
      mbCartCount: 0,
      mbSkuDrawerOpen: false,
      mbColorKey: '',
      mbSize: '',
      mbDraftQty: 1,
      mbDraftRemark: '',
      mbDraftFileimg: '',
      mbPendingOrders: null,
    }
  },
  computed: {
    skuItemsForColor() {
      if (!this.Basket || !this.Basket.length) return []
      if (this.isAllColors) return this.Basket
      return this.Basket.filter(item => String(item.color_id) === String(this.Color.id))
    },
    isAllColors() {
      return !this.Color || this.Color.id == null || this.Color.id === ''
    },
    skuCollapseThreshold() {
      return SKU_COLLAPSE_AT
    },
    showSkuToggle() {
      return this.skuItemsForColor.length > SKU_COLLAPSE_AT
    },
    skuHiddenCount() {
      return Math.max(0, this.skuItemsForColor.length - SKU_COLLAPSE_AT)
    },
    skuPanelExpanded() {
      return this.skuExpanded || !this.showSkuToggle
    },
    /** รายการที่ render จริง — ย่อแล้วเหลือ 5 แถว (ใช้แทน max-height บนมือถือ) */
    displayedSkuItems() {
      const items = this.skuItemsForColor
      if (this.skuPanelExpanded) return items
      return items.slice(0, SKU_COLLAPSE_AT)
    },
    colorList() {
      const c = this.Product && this.Product.color
      return (c && c.list) || []
    },
    showColorToggle() {
      return this.colorList.length > COLOR_COLLAPSE_AT
    },
    colorHiddenCount() {
      return Math.max(0, this.colorList.length - COLOR_COLLAPSE_AT)
    },
    colorPanelExpanded() {
      return this.colorExpanded || !this.showColorToggle
    },
    galleryCountText() {
      const list = (this.Product && this.Product.external_image) || []
      const n = list.filter(item => item && (item.image || item.thumnail)).length
      if (!n) return ''
      const i = typeof this.actv === 'number' && this.actv >= 0 ? this.actv + 1 : 1
      return `${Math.min(i, n)}/${n}`
    },
    mbSkuUnitCny() {
      return this.mbActiveSku ? Number(this.mbActiveSku.price || 0) : 0
    },
    mbUnitThbText() {
      const rate = Number(this.Rate) || 0
      if (this.mbActiveSku) return this.mbFmt(this.mbSkuUnitCny * rate)
      return this.mbPricePair(rate).thb
    },
    mbUnitCnyText() {
      if (this.mbActiveSku) return this.mbFmt(this.mbSkuUnitCny)
      return this.mbPricePair(1).cny
    },
    mbTotalThbText() {
      const rate = Number(this.Rate) || 0
      if (this.mbActiveSku) return this.mbFmt(this.mbSkuUnitCny * rate * this.mbDraftQtySafe)
      return this.mbPricePair(rate).thb
    },
    mbTotalCnyText() {
      if (this.mbActiveSku) return this.mbFmt(this.mbSkuUnitCny * this.mbDraftQtySafe)
      return this.mbPricePair(1).cny
    },
    mbStickyThb() {
      return this.mbTotalThbText
    },
    mbStickyCny() {
      return this.mbTotalCnyText
    },
    mbLiveCnyLine() {
      if (this.mbActiveSku) return `¥ ${this.mbUnitCnyText}`
      const p = this.Product || {}
      if (p.priceRange && p.priceRange.length) {
        const vals = p.priceRange.map(row => Number(row[1]) || 0)
        const min = Math.min(...vals)
        const max = Math.max(...vals)
        if (min !== max) return `¥ ${this.mbFmt(min)} ~ ¥ ${this.mbFmt(max)}`
        return `¥ ${this.mbFmt(min)}`
      }
      const min = Number(p.min_price) || 0
      const max = Number(p.max_price) || min
      if (min && max && min !== max) return `¥ ${this.mbFmt(min)} ~ ¥ ${this.mbFmt(max)}`
      return min ? `¥ ${this.mbFmt(min)}` : ''
    },
    mbLiveThbLine() {
      const rate = Number(this.Rate) || 0
      if (this.mbActiveSku) return `฿ ${this.mbUnitThbText}`
      const p = this.Product || {}
      if (p.priceRange && p.priceRange.length) {
        const vals = p.priceRange.map(row => Number(row[1]) || 0)
        const min = Math.min(...vals)
        const max = Math.max(...vals)
        if (min !== max) return `฿ ${this.mbFmt(min * rate)} ~ ฿ ${this.mbFmt(max * rate)}`
        return `฿ ${this.mbFmt(min * rate)}`
      }
      const min = Number(p.min_price) || 0
      const max = Number(p.max_price) || min
      if (min && max && min !== max) {
        return `฿ ${this.mbFmt(min * rate)} ~ ฿ ${this.mbFmt(max * rate)}`
      }
      return min ? `฿ ${this.mbFmt(min * rate)}` : ''
    },
    mbDraftQtySafe() {
      return Math.max(1, Number(this.mbDraftQty) || 1)
    },
    mbSkuGroups() {
      const map = {}
      const list = []
      ;(this.Basket || []).forEach(item => {
        const key = this.mbSkuColorKey(item)
        const size = this.mbSkuSize(item)
        if (!map[key]) {
          const group = {
            key,
            label: this.mbSkuColorLabel(item),
            image: this.skuSpecImg(item) || item.color_img || '',
            sizes: [],
            skus: [],
          }
          map[key] = group
          list.push(group)
        }
        map[key].skus.push(item)
        if (size && map[key].sizes.indexOf(size) === -1) map[key].sizes.push(size)
        if (!map[key].image && this.skuSpecImg(item)) map[key].image = this.skuSpecImg(item)
      })
      return list
    },
    mbHasSize() {
      return (this.Basket || []).some(item => Boolean(this.mbSkuSize(item)))
    },
    mbStepped() {
      const groups = this.mbSkuGroups
      return (this.Basket || []).length > 1 && (groups.length > 1 || this.mbHasSize)
    },
    mbActiveSku() {
      if (!this.mbStepped) {
        return (this.Basket || []).find(item => this.mbSkuKey(item) === this.mbColorKey) || null
      }
      if (!this.mbColorKey) return null
      if (this.mbHasSize && !this.mbSize) return null
      return (this.Basket || []).find(item => {
        if (this.mbSkuColorKey(item) !== this.mbColorKey) return false
        if (!this.mbHasSize) return true
        return this.mbSkuSize(item) === this.mbSize
      }) || null
    },
    mbSkuReady() {
      return Boolean(this.mbActiveSku)
    },
    mbActiveSkuKey() {
      return this.mbActiveSku ? this.mbSkuKey(this.mbActiveSku) : ''
    },
    mbDrawerThumb() {
      if (this.mbActiveSku) return this.skuSpecImg(this.mbActiveSku) || this.selectedImg
      const group = this.mbSkuGroups.find(g => g.key === this.mbColorKey)
      return (group && group.image) || this.selectedImg || ''
    },
    mbDrawerSkuLabel() {
      if (!this.mbActiveSku) return ''
      return this.skuSpecName(this.mbActiveSku)
    },
    mbPickerBind() {
      return {
        groups: this.mbSkuGroups,
        flatSkus: this.Basket || [],
        colorKey: this.mbColorKey,
        size: this.mbSize,
        hasSize: this.mbHasSize,
        stepped: this.mbStepped,
        draftQty: this.mbDraftQtySafe,
        ready: this.mbSkuReady,
        skuImg: item => this.skuSpecImg(item),
        skuLabel: item => this.skuSpecName(item),
        skuKey: item => this.mbSkuKey(item),
        skuQty: item => this.mbSkuQty(item),
        isActiveSku: item => this.mbIsActiveSku(item),
        sizeAvailable: sz => this.mbSizeAvailable(sz),
        sizeQty: sz => this.mbSizeQty(sz),
      }
    },
  },
  created() {
    this.$nextTick(() => {
      this.resetSkuExpandForColor()
    })
  },
  watch: {
    Color: {
      handler() {
        this.resetSkuExpandForColor()
      },
      deep: true,
    },
    skuItemsForColor: {
      handler() {
        this.resetSkuExpandForColor()
      },
    },
    Basket: {
      handler(val) {
        if (val && val.length) {
          this.$nextTick(() => this.selectAllColors())
        }
      },
    },
    selectedImg(val) {
      if (!this.previewSkuId) return
      const item = (this.Basket || []).find(i => this.skuPreviewKey(i) === this.previewSkuId)
      if (!item || this.skuSpecImg(item) !== val) {
        this.previewSkuId = ''
      }
    },
    'Product.external_image': {
      handler() {
        this.$nextTick(() => {
          this.updateThumbScroll()
          window.setTimeout(() => this.updateThumbScroll(), 300)
        })
      },
    },
    ShowProduct(val) {
      if (val === false) {
        this.$root.$emit('product-search-done')
      }
    },
    /** หมายเหตุ/ไฟล์แนบผูกกับตัวเลือกเดียว — เปลี่ยนตัวเลือกแล้วต้องไม่ติดไปด้วย */
    mbActiveSkuKey() {
      this.mbDraftRemark = ''
      this.mbDraftFileimg = ''
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.updateThumbScroll()
      window.setTimeout(() => this.updateThumbScroll(), 300)
    })
    this._onThumbResize = () => this.updateThumbScroll()
    window.addEventListener('resize', this._onThumbResize)
    this.fetchMbCartCount()
  },
  beforeDestroy() {
    if (this._onThumbResize) {
      window.removeEventListener('resize', this._onThumbResize)
    }
    if (this.ShowProduct) {
      this.$root.$emit('product-search-done')
    }
    document.body.style.overflow = ''
  },
  methods: {
    mbFmt(n) {
      const x = Number(n) || 0
      if (typeof this.Commas === 'function') return this.Commas(x)
      return x.toLocaleString('en-US', { maximumFractionDigits: 2 })
    },
    mbPricePair(rate) {
      const p = this.Product || {}
      const mul = Number(rate) || 0
      if (p.priceRange && p.priceRange.length) {
        const vals = p.priceRange.map(row => Number(row[1]) || 0)
        const min = Math.min(...vals)
        const max = Math.max(...vals)
        if (min !== max) {
          return {
            thb: `${this.mbFmt(min * mul)} ~ ${this.mbFmt(max * mul)}`,
            cny: `${this.mbFmt(min)} ~ ${this.mbFmt(max)}`,
          }
        }
        return { thb: this.mbFmt(min * mul), cny: this.mbFmt(min) }
      }
      const min = Number(p.min_price) || 0
      const max = Number(p.max_price) || min
      if (min && max && min !== max) {
        return {
          thb: `${this.mbFmt(min * mul)} ~ ${this.mbFmt(max * mul)}`,
            cny: `${this.mbFmt(min)} ~ ${this.mbFmt(max)}`,
        }
      }
      return { thb: this.mbFmt(min * mul), cny: min ? this.mbFmt(min) : '' }
    },
    fetchMbCartCount() {
      if (!this.$http) return
      this.$http
        .get('/cart/mycart')
        .then(res => {
          const shops = (res.data && res.data.shops) || []
          this.mbCartCount = shops.reduce(
            (acc, shop) => acc + ((shop.products && shop.products.length) || 0),
            0,
          )
        })
        .catch(() => {})
    },
    mbSkuKey(item) {
      if (!item) return ''
      return [
        item.sku_id,
        item.color_id,
        item.size_id,
        item.color_title,
        item.size_title,
      ].map(v => (v == null ? '' : String(v))).join('|')
    },
    mbSkuColorKey(item) {
      if (!item) return '__option__'
      if (item.color_id != null && item.color_id !== '') return String(item.color_id)
      const title = item.color_title ? String(item.color_title).trim() : ''
      return title || '__option__'
    },
    mbSkuColorLabel(item) {
      if (!item) return this.$t('pdOption')
      return (item.color_title && String(item.color_title).trim())
        || (item.color_id != null ? String(item.color_id) : '')
        || this.skuSpecName(item)
    },
    mbSkuSize(item) {
      if (!item) return ''
      return item.size_title ? String(item.size_title).trim() : ''
    },
    mbSkuQty(item) {
      return Number(item && item.order) || 0
    },
    mbIsActiveSku(item) {
      return this.mbActiveSku === item
    },
    mbSizeAvailable(sz) {
      return (this.Basket || []).some(item => {
        if (this.mbSkuSize(item) !== sz) return false
        if (this.mbColorKey && this.mbSkuColorKey(item) !== this.mbColorKey) return false
        return Number(item.quantity) !== 0
      })
    },
    mbSizeQty(sz) {
      return (this.Basket || []).reduce((sum, item) => {
        if (this.mbSkuSize(item) !== sz) return sum
        if (this.mbColorKey && this.mbSkuColorKey(item) !== this.mbColorKey) return sum
        return sum + (Number(item.order) || 0)
      }, 0)
    },
    mbPickColor(key) {
      const group = this.mbSkuGroups.find(g => g.key === key)
      if (!group) return
      this.mbColorKey = key
      if (group.image && typeof this.imgShow === 'function') this.imgShow(group.image)
      if (this.mbHasSize) {
        if (this.mbSkuDrawerOpen && group.sizes[0]) {
          this.mbPickSize(group.sizes[0])
        } else {
          this.mbSize = ''
        }
        return
      }
      const sku = group.skus[0]
      if (sku && this.skuSpecImg(sku)) this.imgShow(this.skuSpecImg(sku))
    },
    mbPickSize(sz) {
      this.mbSize = sz
      let key = this.mbColorKey
      if (!key) {
        const group = this.mbSkuGroups.find(g => (g.sizes || []).indexOf(sz) !== -1)
        if (!group) return
        key = group.key
        this.mbColorKey = key
        if (group.image && typeof this.imgShow === 'function') this.imgShow(group.image)
      }
      const sku = (this.Basket || []).find(item => (
        this.mbSkuColorKey(item) === key && this.mbSkuSize(item) === sz
      ))
      if (sku && this.skuSpecImg(sku)) this.imgShow(this.skuSpecImg(sku))
    },
    mbSelectFlatSku(sku) {
      this.mbColorKey = this.mbSkuKey(sku)
      this.mbSize = this.mbSkuSize(sku)
      if (this.skuSpecImg(sku)) this.imgShow(this.skuSpecImg(sku))
    },
    mbSetDraftQty(qty) {
      const n = Math.max(1, Number(qty) || 1)
      const max = this.mbActiveSku ? Number(this.mbActiveSku.quantity) || n : n
      this.mbDraftQty = Math.min(n, max)
    },
    mbSetDraftRemark(value) {
      this.mbDraftRemark = value == null ? '' : String(value)
    },
    mbSetDraftFile(file) {
      if (!file || !file.type || !file.type.startsWith('image/')) return
      const reader = new FileReader()
      reader.onload = e => {
        this.mbDraftFileimg = e.target.result
      }
      reader.readAsDataURL(file)
    },
    mbClearDraftFile() {
      this.mbDraftFileimg = ''
    },
    mbOpenSkuDrawer() {
      this.mbSkuDrawerOpen = true
      if (!this.mbColorKey && this.mbSkuGroups[0]) {
        this.mbPickColor(this.mbSkuGroups[0].key)
      }
      document.body.style.overflow = 'hidden'
    },
    mbCloseSkuDrawer() {
      this.mbSkuDrawerOpen = false
      document.body.style.overflow = ''
    },
    mbPreviewDrawer() {
      if (typeof this.openProductLightbox === 'function') this.openProductLightbox()
    },
    mbTakeCartOrders() {
      if (this.mbPendingOrders && this.mbPendingOrders.length) {
        const list = this.mbPendingOrders
        this.mbPendingOrders = null
        return list
      }
      return (this.Basket || [])
        .filter(product => Number(product.order) > 0)
        .map(item => ({ ...item, order: Number(item.order) }))
    },
    mbConfirmSku() {
      const sku = this.mbActiveSku
      if (!sku || typeof this.AddCart !== 'function') return
      const qty = this.mbDraftQtySafe
      const max = Number(sku.quantity) || qty
      const sendQty = Math.min(max, qty)
      if (sendQty < 1) return
      const line = JSON.parse(JSON.stringify(sku))
      line.order = sendQty
      if (this.mbDraftRemark) line.remark = this.mbDraftRemark
      if (this.mbDraftFileimg) line.fileimg = this.mbDraftFileimg
      this.mbPendingOrders = [line]
      this.mbCloseSkuDrawer()
      this.AddCart()
      this.mbDraftRemark = ''
      this.mbDraftFileimg = ''
      window.setTimeout(() => this.fetchMbCartCount(), 800)
    },
    onMbAddCart() {
      this.mbOpenSkuDrawer()
    },
    onMbBuy() {
      this.mbOpenSkuDrawer()
    },
    skuSpecName(item) {
      if (!item) return '-'
      const size = item.size_title ? String(item.size_title).trim() : ''
      const color = item.color_title ? String(item.color_title).trim() : ''
      if (size && color && size !== color) return `${color} / ${size}`
      return size || color || '-'
    },
    proxyProductImg(url) {
      if (!url || typeof url !== 'string') return ''
      const raw = url.trim()
      if (!raw) return ''
      if (
        raw.startsWith('data:')
        || raw.startsWith('/img/')
        || raw.includes('/product/getIMG')
        || raw.includes('images.weserv.nl')
      ) {
        return raw
      }
      let clean = raw
      if (clean.startsWith('//')) clean = `https:${clean}`
      if (typeof this.getImg === 'function') return this.getImg(clean)
      return `${this.$apiBase}/product/getIMG?url=${encodeURIComponent(clean)}`
    },
    skuSpecImg(item) {
      if (!item) return ''
      let src = ''
      if (item.size_img) src = item.size_img
      else if (item.color_img) src = item.color_img
      else {
        const found = this.colorList.find(c => String(c.id) === String(item.color_id))
        src = (found && found.image) || ''
      }
      return this.proxyProductImg(src)
    },
    onSkuImgError(event) {
      if (event && event.target) event.target.src = '/img/no-image.png'
    },
    skuPreviewKey(item) {
      if (!item) return ''
      return [item.color_id, item.size_id, item.sku_id, item.size_title, item.color_title]
        .map(v => (v == null ? '' : String(v)))
        .join('|')
    },
    isPreviewSku(item) {
      return !!this.previewSkuId && this.previewSkuId === this.skuPreviewKey(item)
    },
    previewSkuImage(event, item) {
      if (event && event.target && event.target.closest) {
        if (event.target.closest('.vue-numeric-input, button, input, textarea, a, .btn')) {
          return
        }
      }
      const src = this.skuSpecImg(item)
      if (!src) return
      this.previewSkuId = this.skuPreviewKey(item)
      this.selectedImg = src
      const images = (this.Product && this.Product.external_image) || []
      const idx = images.findIndex(img => img && (img.image === src || img.thumnail === src))
      this.actv = idx >= 0 ? idx : -1
    },
    resetSkuExpandForColor() {
      this.skuExpanded = !this.showSkuToggle
    },
    toggleSkuExpand() {
      this.skuExpanded = !this.skuExpanded
    },
    toggleColorExpand() {
      this.colorExpanded = !this.colorExpanded
    },
    selectAllColors() {
      this.Color = { id: null, title: '' }
      this.actv_color = -1
    },
    thumbScrollAxis() {
      const el = this.$refs.pdThumbs
      if (!el || typeof window === 'undefined') return 'y'
      return window.getComputedStyle(el).flexDirection === 'row' ? 'x' : 'y'
    },
    updateThumbScroll() {
      const el = this.$refs.pdThumbs
      if (!el) {
        this.thumbCanScrollUp = false
        this.thumbCanScrollDown = false
        return
      }
      const axis = this.thumbScrollAxis()
      const pos = axis === 'x' ? el.scrollLeft : el.scrollTop
      const max = axis === 'x'
        ? el.scrollWidth - el.clientWidth
        : el.scrollHeight - el.clientHeight
      this.thumbCanScrollUp = max > 2 && pos > 2
      this.thumbCanScrollDown = max > 2 && pos < max - 2
    },
    openProductLightbox() {
      const list = (this.Product && this.Product.external_image) || []
      const gallery = list
        .map(item => item && (item.image || item.thumnail))
        .filter(Boolean)
        .map(src => ({ path: src }))
      if (!gallery.length && this.selectedImg) {
        gallery.push({ path: this.selectedImg })
      }
      if (!gallery.length) return
      this.images = gallery
      this.showLightbox = true
      this.$nextTick(() => {
        let idx = gallery.findIndex(img => img.path === this.selectedImg)
        if (idx < 0 && typeof this.actv === 'number') idx = this.actv
        if (idx < 0) idx = 0
        if (this.$refs.lightbox && typeof this.$refs.lightbox.showImage === 'function') {
          this.$refs.lightbox.showImage(idx)
        }
      })
    },
    scrollThumbs(dir) {
      const el = this.$refs.pdThumbs
      if (!el) return
      const axis = this.thumbScrollAxis()
      const step = 124
      el.scrollBy({
        left: axis === 'x' ? dir * step : 0,
        top: axis === 'x' ? 0 : dir * step,
        behavior: 'smooth',
      })
      window.setTimeout(() => this.updateThumbScroll(), 180)
    },
  },
}
